export default [
  {
    code:'LKA',
    name:'Sri Lanka',
  },
  {
    code:'MYS',
    name:'Malaysia',
  },
]